import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { Navigate } from 'react-router-dom';
import { auth } from './FirebaseConfig';
import Dashboard from './Sidebar'; // assuming Dashboard is in admin folder

const Authenticate = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show loading while checking authentication
  }

  return user ? <Dashboard /> : <Navigate to="/admin" />;
};

export default Authenticate;
